module.exports = __webpack_public_path__ + "media/images/piscine extérieure chauffée-cf79e5414df8caeca262cf634e1089fd.svg";